module.exports = __webpack_public_path__ + "assets/media/1.19827883.wav";